import { msal } from 'kes-common';

import { MSAL_CLIENT_ID, MSAL_REDIRECT_URI, MSAL_TENANT_ID } from '@/constants';

export default msal.msalInstanceFactory({
	clientId: MSAL_CLIENT_ID,
	redirectUri: MSAL_REDIRECT_URI,
	tenantId: MSAL_TENANT_ID,
});
